import React from 'react';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';
import Header from '../Header';
import Footer from '../Footer';
import CookiesDisclaimer from '../CookiesDisclaimer';
import s from './Layout.css';

function Layout(props) {
  return (
    <div>
      <Header page={props.page} guests={props.guests} whyHostHeader={props.whyHostHeader} whyHostSearchHide={props.whyHostSearchHide} viewListingHeader={props.viewListingHeader} />
      <main>{props.children}</main>
      <Footer />
      <CookiesDisclaimer />
    </div>
  )
}
export default compose(
  withStyles(s),
)(Layout);
